"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const models_1 = require("@osmosys/models");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const change_case_1 = require("change-case");
exports.Search = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, () => {
            return (react_1.default.createElement(react_select_1.default, { options: models_1.allEntities.reduce((acc, entity) => [
                    ...acc,
                    { label: change_case_1.sentenceCase(entity.name), value: entity.name },
                ], []) }));
        })));
};
exports.default = exports.Search;
//# sourceMappingURL=Search.js.map